<template>
  <div>
    <CustomerForm ref="customerForm" :selectedCustomer="selectedCustomer" :for="customerFormFor" />

    <CustomerView ref="customerView" :data="selectedCustomer" />
    <div class="customer pc_container">
      <div class="pc_leftArea">
        <b-popover v-if="help_tooltip_visible" :show.sync="help_tooltip_visible" :placement="'top'"
          target="popover-cusearch-sync" variant="danger">
          <strong>CTRL + {{ keyShortcuts.change_customer }}</strong>
        </b-popover>
        <v-select v-model="selectedCustomer" @search="searchCustomer" class="select_ pick_customer_select"
          id="popover-cusearch-sync" ref="searchCustomerlist" :getOptionLabel="(option) => option.name"
          :options="customerSearchList" placeholder="Select Customer" @input="setSelectedCustomer()"></v-select>
      </div>
      <div class="pc_rightArea">
        <b-button :disabled="isDisabled" v-shortkey="sck.EDITCUSTOMER" @shortkey="openCustomerEditModal()"
          @click="openCustomerEditModal()" size="sm" variant="outline-success" class='float-right'>
          <i class="fa fa-edit"></i>
        </b-button>

        <b-button :disabled="isDisabled" v-shortkey="sck.VIEWCUSTOMER" id="popover-cusview-sync"
          @shortkey="openCustomerViewModal()" @click="openCustomerViewModal()" size="sm" variant="outline-danger"
          class='float-right'>
          <i class="fa fa-eye"></i>
        </b-button>
        <b-popover v-if="help_tooltip_visible" :show.sync="help_tooltip_visible" :placement="'topleft'"
          target="popover-cusview-sync" variant="danger">
          <strong>CTRL + {{ keyShortcuts.customer_view }}</strong>
        </b-popover>
        <b-button size="sm" id="popover-cusvcreate-sync" v-shortkey="sck.CREATECUSTOMER"
          @shortkey="openCustomerCreateModal()" @click="openCustomerCreateModal()" variant="outline-info"
          class='float-right'>
          <i class="fa fa-plus"></i>
        </b-button>
        <b-popover v-if="help_tooltip_visible" :show.sync="help_tooltip_visible" :placement="'topright'"
          variant="danger" target="popover-cusvcreate-sync">
          <strong>CTRL + {{ keyShortcuts.add_customer }}</strong>
        </b-popover>
      </div>
    </div>
    <!-- <b-input-group class="mt-3">
      <b-form-input></b-form-input>

      <b-form-select size="sm" value="null" :options="customers">
        <template v-slot:first>
          <b-form-select-option :value="null" disabled>
            Choose customer type
          </b-form-select-option>
        </template>
      </b-form-select>

      <b-input-group-append> </b-input-group-append>
    </b-input-group> -->
  </div>
</template>

<script>
import CustomerForm from "@/components/Customer/CustomerForm";
import CustomerView from "@/components/Customer/CustomerView";
import ShortCutKeys from "@/mixins/ShortCutKeys";
import { mapState } from "vuex";

export default {
  name: "PickCustomer",
  mixins: [ShortCutKeys],
  components: {
    CustomerForm,
    CustomerView,
  },
  data: () => ({
    customers: ["Walk in customer", "Daily Buyers"],
    customerSearchList: [{ name: "Walk in customer", id: 1 }],
    selectedCustomer: { name: "Walk in customer", id: 1 },
    customerFormFor: "create",
    showPopups: true,
  }),
  methods: {
    setSelectedCustomer() {
      this.$store.commit("bill/SET_CUSTOMER", this.selectedCustomer);
      if (this.selectedCustomer != null) this.customerPendingSales();
    },
    customerPendingSales() {
      this.$store.dispatch(
        "sales/fetchCustomerCashPendingSales",
        this.selectedCustomer.id
      );
    },
    searchCustomer: function (search, loading) {
      this.$store
        .dispatch("customer/search", { query: search })
        .then((res) => {
          // this.customerSearchList.unshift({ name: "Walk in customer", id: -1 });
          this.customerSearchList = res.data.data;
        })
        .catch((err) => { });
    },
    async openCustomerCreateModal() {
      await this.SetFor("create");
      await this.$refs.customerForm.initialize();
      await this.$refs.customerForm.showModal();
    },
    openCustomerViewModal() {
      // this.$refs.customerView.initialize();
      this.$refs.customerView.showModal();
    },
    focusSearchCustomer() {
      // this.$refs.customerView.initialize();
      this.$refs.searchCustomerlist.select();
      this.$refs.searchCustomerlist.focus();
    },
    async openCustomerEditModal() {
      await this.SetFor("edit");
      await this.$refs.customerForm.showModal();
    },
    SetFor(value) {
      this.customerFormFor = value;
    },
  },
  computed: {
    isDisabled: function () {
      return this.selectedCustomer === null || this.selectedCustomer.id == -1;
    },
    ...mapState("auth", ["keyShortcuts"]),
    ...mapState("auth", ["help_tooltip_visible"]),
  },
  created: function () {
    this.setSelectedCustomer();
    this.searchCustomer();

    if (this.selectedCustomer != null) this.customerPendingSales();
  },
};
</script>
<style scoped>
@media only screen and (min-width: 1240px) {
  .customer .btn-sm {
    width: 30px;
    height: 40px;
  }
}

@media only screen and (max-width: 1239px) {
  .customer .btn-sm {
    width: 30px;
    height: 28px;
  }
}

.pc_container {
  display: flex;
}

.pc_leftArea {
  display: block;
  width: 100%;
}

.pc_rightArea {
  display: flex;
}


.pick_customer_select .vs__dropdown-toggle {
  width: 100% !important;
}

.customer pc_container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
